import { enableProdMode, importProvidersFrom } from '@angular/core';
import { httpInterceptorProviders, sentryForProd } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { PortalModule } from '@angular/cdk/portal';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AdHocModule } from './app/ad-hoc-layout/ad-hoc.module';
import { CommonModule } from '@angular/common';
import { ClientLayoutModule } from './app/client-layout/client-layout.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { RFRefreshInterceptorInterceptor } from './app/_shared/services/rfrefresh-interceptor.interceptor';
import { DrawerService } from './app/_shared/services/drawer.service';
import { RfHttpInterceptorInterceptor } from './app/_shared/rf-http-interceptor.interceptor';
import {
    HTTP_INTERCEPTORS,
    withInterceptorsFromDi,
    provideHttpClient,
} from '@angular/common/http';
import { AuthService } from './app/_shared/services/auth.service';

/** Things to do only in prod */
if (environment.production) {
    Sentry.init({
        dsn: environment.SentryUri,
        release: environment.version,
        integrations: [Sentry.browserTracingIntegration()],

        tracePropagationTargets: [
            'http://rf.ui:4200/',
            'https://demo.doorspot.com',
            'https://app.doorspot.com',
        ],

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.5,
        environment: environment.name,
    });

    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            AppRoutingModule,
            BrowserModule,
            ClientLayoutModule,
            CommonModule,
            AdHocModule,
            MatCheckboxModule,
            MatSidenavModule,
            MatDatepickerModule,
            MatNativeDateModule,
            PortalModule,
        ),
        AuthService,
        DrawerService,
        RfHttpInterceptorInterceptor,
        sentryForProd,
        httpInterceptorProviders,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RFRefreshInterceptorInterceptor,
            multi: true,
        },
        {
            // Require all dialogs to be closed explicitly (X/Cancel/Save
            // button). Blocks backdrop click and Escape key by default.
            // Individual dialogs may still opt out via disableClose: false.
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { disableClose: true },
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ],
}).catch((err) => console.error(err));
